export const emptySnapshot = { what_they_sell: "", who_pays: "", revenue_streams: "", niche: "", what_they_are_NOT: "" };

export const snapshotToEditor = (s) => ({
  what_they_sell: s?.what_they_sell || "",
  who_pays: s?.who_pays || "",
  revenue_streams: (s?.revenue_streams || []).join("\n"),
  niche: s?.niche || "",
  what_they_are_NOT: s?.what_they_are_NOT || "",
});

export const snapshotFromEditor = (e) => ({
  what_they_sell: e.what_they_sell.trim(),
  who_pays: e.who_pays.trim(),
  revenue_streams: e.revenue_streams.split("\n").map((s) => s.trim()).filter(Boolean),
  niche: e.niche.trim(),
  what_they_are_NOT: e.what_they_are_NOT.trim(),
});

export const snapshotEditorValid = (e) =>
  e.what_they_sell.trim() && e.who_pays.trim() && e.revenue_streams.split("\n").some((s) => s.trim()) && e.niche.trim() && e.what_they_are_NOT.trim();

const Label = ({ children }) => (
  <label className="font-mono-j text-[10px] tracking-[0.12em] text-[#54505B] uppercase block mb-1.5">{children}</label>
);

export const SnapshotEditor = ({ snap, setSnap }) => {
  const set = (k, v) => setSnap((s) => ({ ...s, [k]: v }));
  return (
    <div className="space-y-4" data-testid="snapshot-editor">
      <div>
        <Label>What you sell</Label>
        <textarea rows={2} className="field-input resize-none" value={snap.what_they_sell} onChange={(e) => set("what_they_sell", e.target.value)} data-testid="snapshot-what-they-sell" />
      </div>
      <div>
        <Label>Who pays you</Label>
        <input className="field-input" value={snap.who_pays} onChange={(e) => set("who_pays", e.target.value)} data-testid="snapshot-who-pays" />
      </div>
      <div>
        <Label>Revenue streams — one per line</Label>
        <textarea rows={3} className="field-input resize-none" value={snap.revenue_streams} onChange={(e) => set("revenue_streams", e.target.value)} data-testid="snapshot-revenue-streams" />
      </div>
      <div>
        <Label>Your niche</Label>
        <input className="field-input" value={snap.niche} onChange={(e) => set("niche", e.target.value)} data-testid="snapshot-niche" />
      </div>
      <div>
        <Label>What you are NOT</Label>
        <textarea rows={2} className="field-input resize-none" value={snap.what_they_are_NOT} onChange={(e) => set("what_they_are_NOT", e.target.value)} data-testid="snapshot-what-they-are-not" />
      </div>
    </div>
  );
};
